import { render, staticRenderFns } from "./IosInappBrowserWarningDialog.vue?vue&type=template&id=38d140f2&scoped=true"
import script from "./IosInappBrowserWarningDialog.vue?vue&type=script&lang=js"
export * from "./IosInappBrowserWarningDialog.vue?vue&type=script&lang=js"
import style0 from "./IosInappBrowserWarningDialog.vue?vue&type=style&index=0&id=38d140f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d140f2",
  null
  
)

export default component.exports